<template>
    <v-dialog
                v-model="dialog.show"
                width="950px"
        >
            <v-card class="pa-8 elevation-0"
                    tile
            >
                    <v-card-title class="headline pt-0 mx-auto justify-center">
                        <h2 class="font-weight-bolder text-left font-family-1 font-size-30">Documentos Necesarios para operar la aplicación</h2>
                    </v-card-title>
                <v-card-text>
                  <v-row>
                      <v-col>
                        <v-stepper alt-labels>
                            <v-stepper-header>
                                <v-stepper-step step="1" complete>
                                Cargar Documentos
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step step="2" complete>
                                Guardar y Enviar
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step step="3">
                                Visación de Documentos
                                </v-stepper-step>

                                 <v-divider></v-divider>

                                <v-stepper-step step="4" :rules="[() => false]">
                                Cierre
                                </v-stepper-step>
                            </v-stepper-header>
                        </v-stepper>
                      </v-col>
                  </v-row>
                  
                  <v-row justify="start" align="center" class="border-bottom-1 align-center">
                      <v-col cols="5">
                          <p class="mb-0 mr-3"> <v-icon class="mr-2" color="green"> mdi-check-bold </v-icon> Mandato, automatizacion para emitir ofertas</p>
                          <i class="font-size-12">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</i>
                      
                      </v-col>
                      <v-col cols="3">
                          <b>
                              Mandato20-03-2020.pdf
                          </b>
                      </v-col>
                      <v-col cols="4" class="justify-center d-flex">
                          <v-btn color="primary"
                            x-small
                            raised
                            dark
                            class="pa-4">Cargar Documento</v-btn>
                      
                          <v-btn color="primary"
                           x-small
                            outlined
                            class="py-4 ml-2">Descargar Planilla</v-btn>
                       </v-col>
                  </v-row>
                  <v-row justify="start" align="center" class="border-bottom-1 align-center">
                      <v-col cols="5">
                          <p class="mb-0 mr-3"> <v-icon class="mr-2" color="orange"> mdi-alert-circle-outline </v-icon>Poder otrogado por la empresa quien autoriza</p>
                          <i class="font-size-12">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</i>
                      
                      </v-col>
                      <v-col cols="3">
                          <p class="mb-0">
                              Seleccione el documento PDF
                          </p>
                      </v-col>
                      <v-col cols="4" class="justify-center d-flex">
                          <v-btn color="primary"
                            x-small
                            raised
                            dark
                            class="pa-4 ">Cargar Documento</v-btn>
                      
                          <v-btn color="primary"
                           x-small
                            outlined
                            class="py-4 ml-2">Descargar Planilla</v-btn>
                       </v-col>
                  </v-row>
                  <v-row justify="start" align="center" class="border-bottom-1 align-center d-flex">
                      <v-col cols="5">
                          <p class="mb-0 mr-3"> <v-icon class="mr-2" color="orange"> mdi-alert-circle-outline </v-icon>Copia Cédula de identidad de quien autoriza</p>
                          <i class="font-size-12">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</i>
                      </v-col>
                      <v-col cols="3">
                          <p class="mb-0">
                             Seleccione el documento PDF
                          </p>
                      </v-col>
                      <v-col cols="4" class="justify-center d-flex">
                          <v-btn color="primary"
                            x-small
                            raised
                            dark
                            class="pa-4">Cargar Documento</v-btn>
                      
                          <v-btn color="primary"
                           x-small
                            outlined
                            class="py-4 ml-2">Descargar Planilla</v-btn>
                       </v-col>
                  </v-row>
                    <v-row class="border-bottom-1 align-center">
                        <v-btn color="primary"
                        to="/system/terms"
                       text
                       class="mx-auto">Ver Terminos y condiciones</v-btn>
                    </v-row>
                    <v-row class="justify-center align-center mt-4">
                        <v-col cols="12" lg="8" >
                             <v-row class="caption">
                                    <v-col class="py-0">
                                        <h3>Beneficios</h3>
                                    </v-col>
                                </v-row>
                              
                                <v-row class="caption">
                                    <v-col class="py-0"> <v-icon color="green"> mdi-check </v-icon>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</v-col>
                                </v-row>
                                <v-row class="caption">
                                    <v-col class="py-0"> <v-icon color="green"> mdi-check </v-icon>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</v-col>
                                </v-row>
                                <v-row class="caption">
                                    <v-col class="py-0">  <v-icon color="green"> mdi-check </v-icon> Lorem ipsum dolor sit amet, consectetur adipiscing elit.</v-col>
                                </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn color="primary"
                      outlined
                       raised
                       dark
                       @click="dialog.show = false"
                       class="pa-6">Guardar</v-btn>

                        <v-btn color="#55B303"
                       raised
                       dark
                       @click="dialog.show = false"
                       class="pa-6">Enviar</v-btn>
                </v-card-actions>

            </v-card>

        </v-dialog>
</template>

<script>
    export default {
        name: 'DocumentLoadedComponent',
        data() {
            return {
                 dialog:{
                     show:false
                 }
            }
        }
    }
</script>